import { FileCheck2, KeyRound, Lock, Shield } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ComingSoonHint } from "./ComingSoonHint.js";
import { SettingsSectionPage } from "./SettingsSectionPage.js";

export function SecurityDataSettingsPage(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <SettingsSectionPage
      testId="settings-security-data-page"
      icon={Shield}
      title={t("settings.securityData.title")}
      description={t("settings.securityData.description")}
    >
      <div className="mx-auto grid w-full max-w-[68rem] gap-5">
        <div className="overflow-hidden rounded-2xl border border-line/70 bg-surface shadow-[0_8px_28px_-18px_rgb(19_42_39/0.12)]">
         

          <div className="p-6">
            <div className="rounded-2xl border border-dashed border-[#163a37]/25 bg-[#163a37]/[0.03] px-5 py-5">
              <ComingSoonHint descriptionKey="settings.securityData.comingSoonHint" />
            </div>

            <div className="mt-5 grid grid-cols-1 gap-3.5 sm:grid-cols-3">
              <div className="flex items-start gap-3 rounded-xl border border-line/60 bg-canvas/50 p-4">
                <span className="inline-grid size-8 shrink-0 place-items-center rounded-lg bg-[#132a27]/10 text-[#132a27]">
                  <Lock size={15} aria-hidden="true" />
                </span>
                <div className="min-w-0">
                  <p className="m-0 text-[0.8125rem] font-semibold text-foreground">
                    {t("settings.securityData.encryption")}
                  </p>
                  
                </div>
              </div>

              <div className="flex items-start gap-3 rounded-xl border border-line/60 bg-canvas/50 p-4">
                <span className="inline-grid size-8 shrink-0 place-items-center rounded-lg bg-[#132a27]/10 text-[#132a27]">
                  <KeyRound size={15} aria-hidden="true" />
                </span>
                <div className="min-w-0">
                  <p className="m-0 text-[0.8125rem] font-semibold text-foreground">
                    {t("settings.securityData.access")}
                  </p>
                
                </div>
              </div>

              <div className="flex items-start gap-3 rounded-xl border border-line/60 bg-canvas/50 p-4">
                <span className="inline-grid size-8 shrink-0 place-items-center rounded-lg bg-[#132a27]/10 text-[#132a27]">
                  <FileCheck2 size={15} aria-hidden="true" />
                </span>
                <div className="min-w-0">
                  <p className="m-0 text-[0.8125rem] font-semibold text-foreground">
                    {t("settings.securityData.retention")}
                  </p>
          
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SettingsSectionPage>
  );
}
